import React from 'react';
import "./style.css";
const ReturnPolicy = () => {
    return (
        <div className='Container'>
            <h2>Return & Refund Policy</h2>
            <div className='privacy'>
                <p>Thank you for shopping with Ganpati Traders ! We value your satisfaction and strive to ensure a seamless and pleasant shopping experience. If you are unsatisfied with your purchase, our Return & Refund Policy outlines the terms and process for returning items and requesting refunds.</p>

                <h4>Eligibility for Returns</h4>
                <p>We accept returns under the following conditions:</p>
                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}><strong>Defective or Damaged Items:</strong> If the product you received is faulty or damaged, it is eligible for returns.</li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}><strong>Incorrect Items:</strong> If you received an item not what you ordered, you can request a return.</li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}><strong>Timeframe:</strong> All return requests must be made within 7 days of receiving your order. Requests made after this period will not be eligible for return.</li>
                </ul>
                <p style={{ color: '#000' }}>Note: To be eligible for a return, the item must be unused, in its original condition, and its original packaging, along with all tags, manuals, and accessories.</p>
                <h4>Items Not Eligible for Return</h4>
                <p>Certain items cannot be returned, including:</p>
                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>Products that show signs of use or wear and tear.</li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>Clearance or sale items marked as "non-returnable."</li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>Items where the seal or packaging has been tampered with.</li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>Downloadable software products and digital goods.</li>
                </ul>

                <h4>How to Initiate a Return</h4>
                <p>To start the return process, please follow these steps:</p>
                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}><strong>Contact Us:</strong> Contact our customer support team at <a href='mailto:info@ganpatitraders.online'>info@ganpatitraders.online</a> with your order details and the reason for the return.</li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}><strong>Provide Proof:</strong> Include clear photos of the item if it's damaged, defective, or incorrect.</li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}><strong>Approval:</strong> Once your return request is reviewed and approved, we will provide further instructions, including the address for returning the product.</li>

                </ul>
                <p>Note: Returns sent without prior approval will not be accepted.</p>

                <h4 style={{ fontSize: '30px' }}>Return Shipping</h4>
                <ul id='ulTag'>

                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Responsibility:</strong> Customers are responsible for the shipping costs of returning an item, except when the return is due to a defective or incorrect product.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Packaging:</strong> Ensure proper packaging of the item to prevent damage during transit. We recommend using the original packaging.
                    </li>
                </ul>


                <h4>Refund Conditions and Process</h4>
                <ul id='ulTag'>

                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Inspection:</strong> Once we receive the returned item, our team will inspect it to ensure it meets the return eligibility criteria.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Refund Approval:</strong> The process will begin immediately if the item is refunded.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Refund Method:</strong> Refunds will be credited to the original payment method used for the purchase.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Processing Time:</strong>
                        <ul style={{ paddingLeft: '20px', listStyle: 'disc' }}>
                            <li style={{ color: '#837f73', fontSize: '18px' }}>
                                Refunds to a bank account or credit card may take 7-10 business days to reflect, depending on your financial institution.
                            </li>
                            <li style={{ color: '#837f73', fontSize: '18px' }}>
                                Refunds to digital payment wallets may be processed faster.
                            </li>
                        </ul>
                    </li>
                </ul>

                <h4>Exceptions to Refunds</h4>
                <p>The following are exceptions under which refunds may be denied:</p>
                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        If the item does not comply with the return eligibility criteria.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        If the item is received in a damaged or altered condition that was not reported initially.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        If the request is initiated after the 7-day allowable window.
                    </li>
                </ul>

                <h4>Non-refundable Fees</h4>
                <p>Specific fees are non-refundable:</p>
                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>Shipping charges for the original order.</li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>Any customs duties, taxes, or handling fees, if applicable.</li>
                </ul>
                <h4>Replacement Options</h4>
                <p>You may request a replacement instead of a refund for defective or damaged items. Replacement requests are subject to stock availability.</p>
              
                <h4>Contact Us</h4>
                <p>If you have any questions about our Return & Refund Policy or need assistance, please feel free to contact us:</p>
                <ul style={{ textDecoration: 'none', listStyle: 'none' }}>
                    <li style={{ fontSize: '18px' }}><strong>Email:</strong> <a href='mailto:info@ganpatitraders.online'>info@ganpatitraders.online</a></li>
                    <li style={{ fontSize: '18px' }}><strong>Customer Support Center:</strong> Available 24/7 through our website.</li>
                </ul>

                <p>We thank you for your trust and support of Ganpati Traders  . Your satisfaction is our priority; we are here to help make things right!</p>
            </div>
        </div>
    )
}

export default ReturnPolicy;